// extracted by mini-css-extract-plugin
export default {"ErrorNotificationContainer":"ErrorNotification_ErrorNotificationContainer__-tTGk"};